import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { OptionHeader } from "../../../../../../../type";
import { ClearButton } from "../../../../../components/MyIconButton";

export function ItemHeaderRangeSelect(props: {
  headerIndex: number;
  selectType: "from" | "to";
  options: number[];
  value: number;
  handleChangeHeader: (
    index: number,
    handleType: "label" | "from" | "to",
    value: string | number
  ) => void;
}) {
  const { headerIndex, selectType, options, value, handleChangeHeader } = props;

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="item-header-select-label">{selectType}</InputLabel>
      <Select
        labelId="item-headerselect-label"
        id="item-header-select"
        value={value}
        onChange={(e: any) => {
          handleChangeHeader(headerIndex, selectType, e.target.value);
        }}
        size="small"
        sx={{
          fontSize: "1rem",
          textAlign: "center",
        }}
        label={selectType}
      >
        {options.map((elm, index) => (
          <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

type Props = {
  headers: OptionHeader[];
  optionLength: number;
  deleteHeader: (index: number) => void;
  handleChangeHeader: (
    index: number,
    handleType: "label" | "from" | "to",
    value: string | number
  ) => void;
};

export function ItemHeaderArea(props: Props) {
  const { headers, optionLength, deleteHeader, handleChangeHeader } = props;

  const [labels, setLabels] = React.useState<string[]>([]);

  function handleLabelChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) {
    setLabels((prev) => {
      const newLabels = [...prev];
      newLabels[index] = e.target.value;
      return newLabels;
    });
  }

  useEffect(() => {
    setLabels(headers.map((header) => header.label));
  }, [headers]);

  return (
    <Stack direction={"column"}>
      {headers.map((header, index) => {
        const flexRatio = (header.to && header.from ? header.to - header.from : 1) / optionLength;

        let fromOptions = [];
        let toOptions = [];

        toOptions = Array.from({ length: optionLength }, (_, i) => i + 1).filter(
          (i) => i >= header.from
        );
        fromOptions = Array.from({ length: optionLength }, (_, i) => i + 1).filter((i) =>
          i <= header.to && index > 0 ? i > headers[index - 1].to : true
        );

        return (
          <Stack
            key={index}
            padding={2}
            direction={"column"}
            alignContent={"center"}
            justifyContent={"center"}
            flex={flexRatio}
          >
            <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
              <TextField
                value={labels[index] ?? ""}
                size="small"
                onChange={(e) => handleLabelChange(e, index)}
                onBlur={() => {
                  handleChangeHeader(index, "label", labels[index]);
                }}
              />

              <ClearButton onClick={() => deleteHeader(index)} />
            </Stack>
            <Stack
              direction={"row"}
              spacing={0.5}
              alignItems={"center"}
              justifyContent={"center"}
              marginTop={1}
            >
              <ItemHeaderRangeSelect
                headerIndex={index}
                selectType="from"
                options={fromOptions}
                value={header.from}
                handleChangeHeader={handleChangeHeader}
              />
              <Typography variant="label_S">~</Typography>
              <ItemHeaderRangeSelect
                headerIndex={index}
                selectType="to"
                options={toOptions}
                value={header.to}
                handleChangeHeader={handleChangeHeader}
              />
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
